import { LicenseStatus } from '@mprolab/sdk'
import { baseColors } from '@mprolab/uikit'

export const getNodeStatusColor = (status: LicenseStatus): string => {
  switch (status) {
    case LicenseStatus.TERMINATED:
    case LicenseStatus.INITIAL:
    case LicenseStatus.PAUSED:
      return baseColors.gray6
    case LicenseStatus.SUSPENDED:
      return baseColors.red
    case LicenseStatus.CONFLICT:
      return baseColors.yellow
    case LicenseStatus.OK:
      return baseColors.green
    default:
      return ''
  }
}
